export default __webpack_public_path__ + "static/media/simon-infanger-nFRghBvqSb0-unsplash.2018efb2.jpg";